<template>
  <div id="user-list">
    <cargo-list-add-new
      v-model="isAddNewCargoSidebarActive"
      @refetch-data="getCargo"
    />

    <contadores
      :total="total"
      :ativos="ativos"
    />

    <v-card>
      <v-card-title> Filtrar </v-card-title>
      <v-row class="px-2 ma-0">
        <v-col
          sm="4"
          cols="12"
        >
          <v-select
            v-model.trim="filtros"
            dense
            outlined
            clearable
            hide-details
            item-text="title"
            item-value="value"
            placeholder="Selecionar por Status"
            :items="opcoes"
            @change="getCargo"
          />
        </v-col>
      </v-row>

      <v-divider class="mt-4"></v-divider>

      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <v-text-field
          v-model.trim="search"
          dense
          outlined
          hide-details
          placeholder="Pesquisar"
          class="user-search me-3 mb-4"
          @keyup="getCargo"
        />

        <v-spacer></v-spacer>

        <div class="d-flex align-center flex-wrap">
          <v-btn
            v-if="!acessoPost"
            color="primary"
            class="mb-4 me-3"
            disabled
          >
            <v-icon>{{ icons.mdiPlus }}</v-icon>
            <span>Criar</span>
          </v-btn>

          <v-btn
            v-else
            color="primary"
            class="mb-4 px-4"
            @click.stop="isAddNewCargoSidebarActive = !isAddNewCargoSidebarActive"
          >
            <v-icon
              left
              size="25"
              class="mr-1"
            >
              {{ icons.mdiPlus }}
            </v-icon>
            <span>Criar</span>
          </v-btn>
        </div>
      </v-card-text>

      <v-col cols="12">
        <div style="min-height: 4px">
          <v-progress-linear
            v-if="loading"
            indeterminate
          />
        </div>

        <table-cargo
          :items="cargos"
          :acesso-disable="acessoDisable"
          @confirmar-inativacao="getCargo"
        />
      </v-col>
    </v-card>
  </div>
</template>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>

<script>
import { onMounted, ref } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import { mdiAccount, mdiPlus } from '@mdi/js'
import TableCargo from '@/components/tables/TableCargo.vue'
import Contadores from '@/views/cargo/contadores.vue'
import CargoListAddNew from './CargoListAddNew.vue'
import CargoService from '@/services/modules/CargoService'
import useAuthStore from '@/store/auth'

export default {
  components: {
    CargoListAddNew,
    TableCargo,
    Contadores,
  },

  setup() {
    const isAddNewCargoSidebarActive = ref(false)

    const opcoes = [
      { title: 'Inativos', value: 'false' },
      { title: 'Ativos', value: 'true' },
    ]

    const { funcionalidades } = storeToRefs(useAuthStore())

    // Estados
    const cargos = ref([])
    const loading = ref(true)
    const search = ref('')
    const filtros = ref('true') // Padrão: ativos
    const idPost = 1015
    const idDisable = 1017
    const acessoPost = ref(true)
    const acessoDisable = ref(true)
    const total = ref([])
    const ativos = ref([])

    function permissoes() {
      if (!funcionalidades.value.includes(idPost)) {
        acessoPost.value = false
      }
      if (!funcionalidades.value.includes(idDisable)) {
        acessoDisable.value = false
      }
    }

    async function getCargo() {
      try {
        loading.value = true

        const data = await CargoService.get()

        cargos.value = data
        total.value = cargos.value
        ativos.value = cargos.value.filter(d => d.ativo)

        setTimeout(() => {
          loading.value = false
        }, 500)
      } catch {
        loading.value = false
      }
    }

    function atualizarFiltro(item) {
      filtros.value = item
      getCargo()
    }

    onMounted(() => {
      getCargo()
      // permissoes()
    })

    return {
      isAddNewCargoSidebarActive,
      opcoes,
      cargos,
      loading,
      search,
      filtros,
      acessoPost,
      acessoDisable,
      total,
      ativos,
      getCargo,
      atualizarFiltro,
      icons: {
        mdiPlus,
        mdiAccount,
      },
    }
  },
}
</script>
